import arrow from "./assets/arrow.mp3";
import arrowwall from "./assets/arrowwall.mp3";
import chest from "./assets/chest.mp3";
import chest2 from "./assets/chest2.mp3";
import crystal from "./assets/crystal.mp3";
import dig from "./assets/dig.mp3";
import dooropen from "./assets/dooropen.mp3";
import enemyhit from "./assets/enemyhit.mp3";
import fightersword from "./assets/fightersword.mp3";
import fightersword2 from "./assets/fightersword2.mp3";
import fire from "./assets/fire.mp3";
import flute1 from "./assets/flute1.mp3";
import hammer from "./assets/hammer.mp3";
import heart from "./assets/heart.mp3";
import itemget from "./assets/itemget.mp3";
import magic from "./assets/magic.mp3";
import spinattack from "./assets/spinattack.mp3";
import track from "./assets/track-min.mp3";
import usekey from "./assets/usekey.mp3";
import walkgrass from "./assets/walkgrass.mp3";
import walkwater from "./assets/walkwater.mp3";
import wallet from "./assets/wallet.mp3";
import water from "./assets/water.mp3";

const fantasy16bit = {
  ambientTrack: [track],
  defaultSound: [walkgrass],
  randomSounds: [
    water,
    walkwater,
    magic,
    heart,
    hammer,
    flute1,
    dooropen,
    chest2,
    chest,
    crystal,
    dig,
    arrowwall,
  ],
  eventSounds: {
    function: [magic, wallet],
    previewReload: [spinattack],
    newFile: [dig, dooropen],
    assign: [arrow, dig],
    openTag: [fightersword, fightersword2, enemyhit, fire],
    reactState: [water, walkwater],
  },
};

export default fantasy16bit;
